import { useEffect } from 'react';
import 'materialize-css';
import 'materialize-css/dist/css/materialize.min.css';
import M from 'materialize-css/dist/js/materialize.min';
import Layout from "../Layout";
// import { BiCheckDouble } from "react-icons/bi";
import school from '../../assets/school.jpg';

import commitment from '../../assets/values/commitment-icon.png';
import integrity from '../../assets/values/integrity-icon.png';
import honesty from '../../assets/values/passion-icon.png';
import pro from '../../assets/values/pro-icon.png';
import target from '../../assets/values/target.svg';
import { Helmet } from 'react-helmet';

const About = () => {
    useEffect(() => {
        var elems = document.querySelectorAll('.parallax');
        M.Parallax.init(elems, {});
    }, []);

    return ( 
        <Layout>
            <Helmet> 
                <meta
                    name="description"
                    content="Life Long Polytechnic is Registered with the Ministry of Higher And Tertiary Education, Science and Technology Development."
                />
                <title>About Life Long Polytechnic</title>
            </Helmet>
            
                <div className="section light-bg">
                    <div className="container">
                        <h5 className="title has-text-weight-bold mt-6 mb-2">About <span className="has-text-weight-light">Us</span></h5>
                        <div className="divider"></div>
                        <div className="row mt-5">
                            <div className="col s12 m5 mt-5">
                                <img src={school} alt="Life Long Polytechnic entrance" className="responsive-img" />
                            </div>
                            <div className="col s12 m6 mt-5 offset-m1">
                                {/* <h6 className="my-1 has-text-weight-bold">HISTORY</h6> */}
                                <p className="small-text mt-3">The institution thrives to expand the TVET teaching and research base by focusing on Applied Arts, Commerce, Engineering, Science and Technology for economic development, among other relevant fields, targeting a group of individuals who are excluded/miss the fortune from State Polytechnics and Universities due to limited enrolment and competition. This will be achieved through Certificates and Diploma Programs, Applied and Translational research, professional development and in-service training, innovation as well as information dissemination.</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* parallax */}
                <div className="para-about">
                    <div className="container para">
                        <h5 className="is-size-3 has-text-weight-bold mb-5 grey-text text-lighten-3 center"><span className="has-text-weight-light">Our</span> Mission</h5>
                        <div className="container">
                            <p className="container center grey-text text-lighten-2">To provide excellent science and technological education with the aim of producing innovative world class skilled graduates.</p>
                        </div>
                    </div>
                </div>
                {/* parallax */}
                {/* vison and values */}
                <div className="light-bg">
                    <div className="container">
                        <div className="v-cont my-5">
                            <div>
                                <div className="center mt-3">
                                    <img src={target} alt="VisionIcon" className="target-svg" />
                                </div>
                                <h5 className="is-size-3 has-text-weight-light mt-4 mb-2 center">Our <span className="has-text-weight-semibold">Vision</span></h5>
                                <p className="center mb-5">To develop and equip learners who are competent and marketable in the global community.</p>
                            </div>
                            <div className="white z-depth-1 px-3 smooth-edge-2">
                                <h5 className="title has-text-weight-bold my-5 center main-color-text">Values</h5>
                                <div className="values">
                                    <div className="valign-wrapper">
                                        <img src={commitment} alt="Commitment-Icon" className="values-icons responsive-img"/>
                                        <span className="is-size-4-touch is-size-5-desktop ml-4 has-text-weight-semibold grey-text text-darken-3">Commitment</span>
                                    </div>
                                    <div className="valign-wrapper">
                                    <img src={integrity} alt="Integrity-Icon" className="values-icons responsive-img"/>
                                        <span className="is-size-4-touch is-size-5-desktop ml-4 has-text-weight-semibold grey-text text-darken-3">Integrity</span>
                                    </div>
                                    <div className="valign-wrapper">
                                        <img src={honesty} alt="Honesty-Icon" className="values-icons responsive-img"/>
                                        <span className="is-size-4-touch is-size-5-desktop ml-4 has-text-weight-semibold grey-text text-darken-3">Honesty</span>
                                    </div>
                                    <div className="valign-wrapper">
                                        <img src={pro} alt="Pro-Icon" className="values-icons responsive-img"/>
                                        <span className="is-size-4-touch is-size-5-desktop ml-4 has-text-weight-semibold grey-text text-darken-3">Professionalism</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* vison and values */}
                {/* teaching staff */}
                {/* <div className="white py-3">
                    <div className="container">
                        <h5 className="is-size-4-mobile is-size-3-tablet has-text-weight-bold mb-2">Our Teaching Staff</h5>
                        <div className="divider"></div>

                        <div className="row mt-5 mb-4">
                            <div className="col s12 m6 l3">
                                <div className="card">
                                    <div className="card-image">
                                        <img src="img/banner.jpg" />
                                    </div>
                                    <div className="card-content">
                                        <h6 className="center has-text-weight-bold mt-0">Teacher Name</h6>
                                        <p className="center small-text grey-text text-darken-1">Hon. degree in Marketing (UZ)</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col s12 m6 l3">
                                <div className="card">
                                    <div className="card-image">
                                        <img src="img/banner.jpg" />
                                    </div>
                                    <div className="card-content">
                                        <h6 className="center has-text-weight-bold mt-0">Teacher Name</h6>
                                        <p className="center small-text grey-text text-darken-1">Hon. degree in Marketing (UZ)</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col s12 m6 l3">
                                <div className="card">
                                    <div className="card-image">
                                        <img src="img/banner.jpg" />
                                    </div>
                                    <div className="card-content">
                                        <h6 className="center has-text-weight-bold mt-0">Teacher Name</h6>
                                        <p className="center small-text grey-text text-darken-1">Hon. degree in Marketing (UZ)</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col s12 m6 l3">
                                <div className="card">
                                    <div className="card-image">
                                        <img src="img/banner.jpg" />
                                    </div>
                                    <div className="card-content">
                                        <h6 className="center has-text-weight-bold mt-0">Teacher Name</h6>
                                        <p className="center small-text grey-text text-darken-1">Hon. degree in Marketing (UZ)</p>
                                    </div>
                                </div>
                            </div>
                        </div>                       
                    </div>
                </div> */}
                {/* teaching staff */}
            
        </Layout>
     );
}
 
export default About;